// (function () {
// 	const slideshow = () => {
// 		document.querySelectorAll(".slideshow").forEach((block) => {
// 			let box = block.closest("section");
// 			let id = box.getAttribute("id");
// 			block = $(block);
// 			const autoplay = block.data("autoplay");
// 			const stopAutoplay = block.data("stop-autoplay");
// 			const delay = block.data("delay") * 1000;
// 			const speed = block.data("speed") * 1000;
// 			const effect = block.data("effect");			
	
// 			let swiperParams = {
// 				speed: speed,
// 				keyboard: true,
// 				loop: true
// 			};
	
// 			let autoplayParams = autoplay ? {
// 				autoplay: {
// 					delay: delay,
// 					disableOnInteraction: false,
// 					pauseOnMouseEnter: stopAutoplay,
// 				},
// 			} : {};

// 			let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
// 			let swiperTextElement = document.querySelector(swiperTextSelector);
	
// 			const swiperText = new Swiper(swiperTextSelector, {
// 				...swiperParams,
// 				//autoplay: false,
// 				spaceBetween: 24,
// 				direction: "horizontal",
// 				slidesPerView: "auto",
// 				//slideToClickedSlide: true,
// 				//loopedSlides: 4,
// 				allowTouchMove: false,

// 				breakpoints: {
// 					990: {
// 						allowTouchMove: true,
// 					},
// 					1600: {
// 						allowTouchMove: false,
// 						touchRatio: 0,
// 						keyboard: {
// 							enabled: false,
// 						},
// 					},
// 				},
// 				on: {
// 					init: function () {
// 						swiperTextElement.classList.add('first_step');
// 					},
// 					slideChange: function () {
// 						swiperTextElement.classList.remove('first_step');
// 					}
// 				}
// 			});

// 			let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
// 			let swiperImgElement = document.querySelector(swiperImgSelector);

	
// 			const swiperImg = new Swiper(swiperImgSelector, {
// 					pagination: {
// 						el: `#${id} .swiper-pagination`,
// 						clickable: true,
// 					},
// 					...swiperParams,
// 					...autoplayParams,
// 					effect: effect,
// 					thumbs: {
// 						swiper: swiperText,
// 					},
// 				on: {
// 					init: function () {
// 						swiperImgElement.classList.add('first_step');
// 						box.style.setProperty('--bullet-duration', `${delay}ms`);
// 					},
// 					slideChange: function () {
// 						box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
// 					},
// 					slideChangeTransitionEnd: function () {
// 						swiperImgElement.classList.remove('first_step');
// 					}
// 				}
// 			});

// 			if (autoplay && stopAutoplay) {
// 				swiperImgElement.addEventListener("mouseenter", function () {
// 						swiperTextElement.classList.add("stop_move");
// 					});
// 					swiperImgElement.addEventListener("mouseleave", function () {
// 						swiperTextElement.classList.remove("stop_move");
// 					});
// 			}

// 			if($(block.find(".slideshow__content")).length === 1) {
// 				swiperImgElement.classList.add('no_slideshow');
// 				swiperTextElement.classList.add('no_slideshow');

// 				swiperImg.destroy(true, true);
// 				swiperText.destroy(true, true);
// 			}
// 		})
// 	}


// 	document.addEventListener("DOMContentLoaded", function () {
// 		slideshow();
// 		document.addEventListener("shopify:section:load", function () {
// 			slideshow();
// 		});
// 	});
// })();




(function () {
    const slideshow = () => {
        document.querySelectorAll(".slideshow").forEach((block) => {
            let box = block.closest("section");
            if (!box) return;
            let id = box.getAttribute("id");
            
            let $block = $(block);
            // Slides count sahi tarah se nikalne ke liye
            const slidesCount = $block.find(".slideshow__content").length;
            
            if (slidesCount === 0) return;

            // Agar sirf 1 slide hai, toh loop aur pagination ki zarurat nahi
            const isLoop = slidesCount > 1;

            const autoplay = $block.data("autoplay");
            const stopAutoplay = $block.data("stop-autoplay");
            const delay = parseFloat($block.data("delay")) * 1000 || 3000;
            const speed = parseFloat($block.data("speed")) * 1000 || 500;
            const effect = $block.data("effect") || "slide";            
    
            let swiperParams = {
                speed: speed,
                keyboard: true,
                loop: isLoop, // Fix: Console error hatane ke liye
                watchSlidesProgress: true,
            };
    
            let autoplayParams = autoplay && isLoop ? {
                autoplay: {
                    delay: delay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: stopAutoplay,
                },
            } : {};

            let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
            let swiperTextElement = document.querySelector(swiperTextSelector);
            
            let swiperText = null;
            if (swiperTextElement) {
                swiperText = new Swiper(swiperTextSelector, {
                    ...swiperParams,
                    spaceBetween: 24,
                    direction: "horizontal",
                    slidesPerView: "auto",
                    allowTouchMove: isLoop,
                    breakpoints: {
                        990: { allowTouchMove: isLoop },
                        1600: { allowTouchMove: false }
                    },
                    on: {
                        init: function () { this.el.classList.add('first_step'); },
                        slideChange: function () { this.el.classList.remove('first_step'); }
                    }
                });
            }

            let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
            let swiperImgElement = document.querySelector(swiperImgSelector);

            if (swiperImgElement) {
                const swiperImg = new Swiper(swiperImgSelector, {
                    ...swiperParams,
                    ...autoplayParams,
                    pagination: {
                        el: `#${id} .swiper-pagination`,
                        clickable: true,
                    },
                    effect: effect,
                    thumbs: swiperText ? { swiper: swiperText } : null, // Fix: Heading connection
                    on: {
                        init: function () {
                            this.el.classList.add('first_step');
                            box.style.setProperty('--bullet-duration', `${delay}ms`);
                        },
                        slideChange: function () {
                            box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
                        },
                        slideChangeTransitionEnd: function () {
                            this.el.classList.remove('first_step');
                        }
                    }
                });

                if (autoplay && stopAutoplay) {
                    swiperImgElement.addEventListener("mouseenter", () => {
                        if(swiperTextElement) swiperTextElement.classList.add("stop_move");
                    });
                    swiperImgElement.addEventListener("mouseleave", () => {
                        if(swiperTextElement) swiperTextElement.classList.remove("stop_move");
                    });
                }
            }
            
            // Single slide handle
            if(slidesCount === 1) {
                if(swiperImgElement) swiperImgElement.classList.add('no_slideshow');
                if(swiperTextElement) swiperTextElement.classList.add('no_slideshow');
            }
        })
    }

    document.addEventListener("DOMContentLoaded", slideshow);
    document.addEventListener("shopify:section:load", slideshow);
})();










// (function () {
//     const slideshow = () => {
//         document.querySelectorAll(".slideshow").forEach((block) => {
//             let box = block.closest("section");
//             if (!box) return; // Error protection
//             let id = box.getAttribute("id");
            
//             let $block = $(block);
//             const slides = $block.find(".slideshow__content");
//             const slidesCount = slides.length;
            
//             // Agar slide sirf 1 hai to slider initialize hi mat karein
//             if (slidesCount <= 1) {
//                 box.classList.add('no_slideshow');
//                 return;
//             }

//             const autoplay = $block.data("autoplay");
//             const stopAutoplay = $block.data("stop-autoplay");
//             const delay = parseFloat($block.data("delay")) * 1000 || 3000;
//             const speed = parseFloat($block.data("speed")) * 1000 || 500;
//             const effect = $block.data("effect") || "slide";            
    
//             // Fix: Loop tabhi karein jab slides 1 se zyada hon
//             let swiperParams = {
//                 speed: speed,
//                 keyboard: true,
//                 loop: slidesCount > 1 
//             };
    
//             let autoplayParams = autoplay ? {
//                 autoplay: {
//                     delay: delay,
//                     disableOnInteraction: false,
//                     pauseOnMouseEnter: stopAutoplay,
//                 },
//             } : {};

//             let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
//             let swiperTextElement = document.querySelector(swiperTextSelector);
            
//             // Text/Tabs Swiper (Only if element exists)
//             let swiperText;
//             if (swiperTextElement) {
//                 swiperText = new Swiper(swiperTextElement, {
//                     ...swiperParams,
//                     spaceBetween: 24,
//                     direction: "horizontal",
//                     slidesPerView: "auto",
//                     allowTouchMove: false,
//                     breakpoints: {
//                         990: { allowTouchMove: true },
//                         1600: { allowTouchMove: false }
//                     },
//                     on: {
//                         init: function () { this.el.classList.add('first_step'); },
//                         slideChange: function () { this.el.classList.remove('first_step'); }
//                     }
//                 });
//             }

//             let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
//             let swiperImgElement = document.querySelector(swiperImgSelector);

//             if (swiperImgElement) {
//                 const swiperImg = new Swiper(swiperImgElement, {
//                     pagination: {
//                         el: `#${id} .swiper-pagination`,
//                         clickable: true,
//                     },
//                     ...swiperParams,
//                     ...autoplayParams,
//                     effect: effect,
//                     thumbs: swiperText ? { swiper: swiperText } : null,
//                     on: {
//                         init: function () {
//                             this.el.classList.add('first_step');
//                             box.style.setProperty('--bullet-duration', `${delay}ms`);
//                         },
//                         slideChange: function () {
//                             box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
//                         }
//                     }
//                 });

//                 // Hover protection fix
//                 if (autoplay && stopAutoplay) {
//                     swiperImgElement.addEventListener("mouseenter", () => {
//                         if(swiperTextElement) swiperTextElement.classList.add("stop_move");
//                     });
//                     swiperImgElement.addEventListener("mouseleave", () => {
//                         if(swiperTextElement) swiperTextElement.classList.remove("stop_move");
//                     });
//                 }
//             }
//         })
//     }

//     // Shopify section load handling
//     document.addEventListener("DOMContentLoaded", slideshow);
//     document.addEventListener("shopify:section:load", slideshow);
// })();